"use client";

import { Phone, TriangleAlert, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToDeploy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ready-to-deploy" className="dark bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" />

      <div ref={ref} className={`max-w-5xl mx-auto relative z-10 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="relative overflow-hidden rounded-2xl border-2 border-destructive/40 bg-gradient-to-b from-destructive/20 to-background/95 backdrop-blur-md p-8 sm:p-12 md:p-16 text-center shadow-[0_0_50px_-12px_var(--color-destructive)]">
          
          {}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-80" />

          <div className="relative z-10 flex flex-col items-center gap-8">
            <div className="inline-flex items-center justify-center p-4 rounded-full bg-destructive/20 text-destructive ring-1 ring-destructive/50 shadow-[0_0_30px_-5px_var(--color-destructive)]">
              <TriangleAlert className="size-10 sm:size-12 animate-pulse" />
            </div>

            <div className="space-y-4">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-foreground uppercase">
                Ready to Deploy <span className="text-primary">24/7</span>
              </h2>
              <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto font-medium">
                Immediate operational support at N’djili International Airport. Our ground handling and logistics teams are on standby for your aircraft.
              </p>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto h-16 sm:h-20 px-6 sm:px-10 text-lg sm:text-xl font-bold rounded-xl shadow-[0_0_30px_-5px_var(--color-primary)] hover:shadow-[0_0_40px_-5px_var(--color-primary)] transition-all border border-primary/50 bg-primary text-primary-foreground hover:bg-primary/90 group" asChild>
                <Link to="tel:+243810641198">
                  <Phone className="mr-3 size-6 sm:size-8 group-hover:animate-bounce" />
                  Call Now: <span className="font-mono ml-3 tracking-wider text-xl sm:text-2xl">+243 840 161 875</span>
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-2 text-sm sm:text-base text-muted-foreground mt-4 bg-background/50 px-4 py-2 rounded-full border border-border/50">
              <Clock className="size-4 sm:size-5 text-primary" />
              <span>Available around the clock for urgent aviation logistics</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}